// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"rankingOrder_visuallyHidden"};